module.exports = __webpack_public_path__ + "img/nodeImg1.7db18b33.png";